import { Text, Center, Spinner } from "@chakra-ui/react";
import { InView } from "react-intersection-observer";

const FetchMoreWhenInView = ({
  fetchNextPage,
  isFetchingNextPage,
  hasNextPage,
}: {
  fetchNextPage: () => void;
  isFetchingNextPage: boolean;
  hasNextPage: boolean | undefined;
}) => {
  const displayText = hasNextPage ? "Loading..." : "Nothing more to load";
  return (
    <Center>
      <InView
        as="div"
        onChange={(inView) => {
          if (inView) {
            fetchNextPage();
          }
        }}
      >
        {/* render <Text> as a div to avoid a DOM validation warning: "<div> element cannot be a child of a <p> element" */}
        <Text as="div" color="grey" fontWeight="semibold" opacity={0.5}>
          {isFetchingNextPage ? <Spinner /> : displayText}
        </Text>
      </InView>
    </Center>
  );
};

export default FetchMoreWhenInView;
